import { type PropsWithChildren } from "react";

export function NavbarBanner({ children }: PropsWithChildren) {
  return (
    <div
      className="h-navbar-banner w-full"
      data-testid="pending-actions-banner"
    >
      {children}
    </div>
  );
}
